import axios from '../../../../shared/axios';

import { AppDispatch } from '../../../../store';
import { validateObj } from '../../../../shared/utils';

import {
  GetAllTwilioPhonesRequest,
  PhoneGroup,
  RemoveTwilioAccountRequest,
  SaveTwilioAccountSettingsRequest,
  SaveTwilioAssignedAgentsRequest,
  TwilioAccount,
} from '../../models';

import * as actionTypes from '../constants/twilio';

const getTwilioAccountSettingsStart = () => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_SETTINGS_START,
  };
};

const getTwilioAccountSettingsSuccess = (data: TwilioAccount) => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_SETTINGS_SUCCESS,
    data,
  };
};

const getTwilioAccountSettingsFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_SETTINGS_FAIL,
    error,
  };
};

export const getTwilioAccountSettings = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<TwilioAccount>((resolve, reject) => {
      dispatch(getTwilioAccountSettingsStart());

      const url = `/twilio/get-settings`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getTwilioAccountSettingsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTwilioAccountSettingsFail(err));
          reject(err);
        });
    });
  };
};

const saveTwilioAccountSettingsStart = () => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_START,
  };
};

const saveTwilioAccountSettingsSuccess = (data: boolean) => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_SUCCESS,
    data,
  };
};

const saveTwilioAccountSettingsFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_FAIL,
    error,
  };
};

export const saveTwilioAccountSettings = (params: SaveTwilioAccountSettingsRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveTwilioAccountSettingsStart());

      const url = `/twilio/save-twilio-account-settings`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(saveTwilioAccountSettingsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveTwilioAccountSettingsFail(err));
          reject(err);
        });
    });
  };
};

const removeTwilioAccountStart = () => {
  return {
    type: actionTypes.TWILIO_REMOVE_TWILIO_ACCOUNT_START,
  };
};

const removeTwilioAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.TWILIO_REMOVE_TWILIO_ACCOUNT_SUCCESS,
    data,
  };
};

const removeTwilioAccountFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_REMOVE_TWILIO_ACCOUNT_FAIL,
    error,
  };
};

export const removeTwilioAccount = (params: RemoveTwilioAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(removeTwilioAccountStart());

      const url = `/twilio/remove-twilio-account`;

      axios
        .delete(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(removeTwilioAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(removeTwilioAccountFail(err));
          reject(err);
        });
    });
  };
};

const getAllTwilioPhonesStart = () => {
  return {
    type: actionTypes.TWILIO_GET_ALL_TWILIO_PHONES_START,
  };
};

const getAllTwilioPhonesSuccess = (data: Array<string>) => {
  return {
    type: actionTypes.TWILIO_GET_ALL_TWILIO_PHONES_SUCCESS,
    data,
  };
};

const getAllTwilioPhonesFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_GET_ALL_TWILIO_PHONES_FAIL,
    error,
  };
};

export const getAllTwilioPhones = (params: GetAllTwilioPhonesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<string>>((resolve, reject) => {
      dispatch(getAllTwilioPhonesStart());

      const url = `/twilio/get-all-twilio-phones`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getAllTwilioPhonesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAllTwilioPhonesFail(err));
          reject(err);
        });
    });
  };
};

export const setAllTwilioPhones = (value: Array<string> | undefined) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: actionTypes.TWILIO_SET_ALL_TWILIO_PHONES,
      data: value,
    });
  };
};

const getTwilioAssignedAgentsStart = () => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_ASSIGNED_AGENTS_START,
  };
};

const getTwilioAssignedAgentsSuccess = (data: Array<PhoneGroup>) => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_ASSIGNED_AGENTS_SUCCESS,
    data,
  };
};

const getTwilioAssignedAgentsFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_GET_TWILIO_ASSIGNED_AGENTS_FAIL,
    error,
  };
};

export const getTwilioAssignedAgents = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<PhoneGroup>>((resolve, reject) => {
      dispatch(getTwilioAssignedAgentsStart());

      const url = `/twilio/get-twilio-assigned-agents`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getTwilioAssignedAgentsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTwilioAssignedAgentsFail(err));
          reject(err);
        });
    });
  };
};

export const setTwilioAssignedAgents = (value: Array<PhoneGroup> | undefined) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: actionTypes.TWILIO_SET_TWILIO_ASSIGNED_AGENTS,
      data: value,
    });
  };
};

const saveTwilioAssignedAgentsStart = () => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_START,
  };
};

const saveTwilioAssignedAgentsSuccess = (data: boolean) => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_SUCCESS,
    data,
  };
};

const saveTwilioAssignedAgentsFail = (error: any) => {
  return {
    type: actionTypes.TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_FAIL,
    error,
  };
};

export const saveTwilioAssignedAgents = (params: SaveTwilioAssignedAgentsRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveTwilioAssignedAgentsStart());

      const url = `/twilio/save-twilio-assigned-agents`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(saveTwilioAssignedAgentsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveTwilioAssignedAgentsFail(err));
          reject(err);
        });
    });
  };
};
